import Constants from 'expo-constants';

export const getApiUrl = () => {
  const { apiUrl } = Constants.expoConfig.extra;

  return apiUrl;
};

export default (url) => (`${getApiUrl()}${url}`);
